import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';

export function provideMsalServices(): EnvironmentProviders {
    return makeEnvironmentProviders([MsalService, MsalGuard, MsalBroadcastService]);
}
